'use strict'

const addComponentEventListener = require('../addComponentEventListener')

module.exports = ({ applicationCodeZone }) => {
  return {
    currentIndexChanged() {},
    currentViewChanged() {},
    currentRecordModified() {},
    recordSetLoaded() {},
    bindToComponent({ connectionConfig, component }, actions) {
      if (typeof component.onChange === 'function') {
        addComponentEventListener(
          component,
          'onChange',
          actions.refresh,
          applicationCodeZone
        )
      }
    },

    isValidContext() {
      return true
    },

    resetUserFilter({ component }) {
      component.value = null
    }
  }
}
